"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhenChunk = exports.ObjectsChunk = exports.Chunk = void 0;
const scope_1 = require("./scope");
const types_1 = require("./types");
class Chunk {
    constructor(members) {
        this.members = members;
    }
}
exports.Chunk = Chunk;
class ObjectsChunk extends Chunk {
    constructor() {
        super([]);
        this.name = types_1.ChunkType.OBJECTS;
    }
    addScope(name) {
        const scope = new scope_1.ObjectScope(name);
        this.members.push(scope);
        return scope;
    }
}
exports.ObjectsChunk = ObjectsChunk;
class WhenChunk extends Chunk {
    constructor() {
        super([]);
        this.name = types_1.ChunkType.WHEN;
    }
    addScope(name) {
        const scope = new scope_1.TimeScope(name);
        this.members.push(scope);
        return scope;
    }
}
exports.WhenChunk = WhenChunk;
